import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getNotificationsList,
  type NotificationsResponseItem,
  getPublicUrlAPI
} from "../../services/apiEndpoints";

export const fetchNotifications = createAsyncThunk<
  NotificationsResponseItem[],
  void,
  { rejectValue: string }
>(
  "notifications/fetchNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getNotificationsList();
      const body = res?.data ?? res;
      const list: NotificationsResponseItem[] = Array.isArray(body?.data)
        ? body.data
        : Array.isArray(body)
        ? body
        : [];
      console.log("Fetched notifications:", list);
      return list;
    } catch (err: any) {
      return rejectWithValue(
        String(err?.response?.data ?? err?.message ?? "Failed to fetch notifications")
      );
    }
  }
);

export const getPublicUrlThunk = createAsyncThunk<
  Blob,
  { fileName?: string; document_name?: string; key_name?: string; moduletype?: string; folderName?: string },
  { rejectValue: string }
>(
  "file/getPublicUrl",
  async ({ fileName, document_name, key_name, moduletype, folderName }, { rejectWithValue }) => {
    try {
      const response = await getPublicUrlAPI({ fileName, document_name, key_name, moduletype, folderName });
      return response.data as Blob;
    } catch (error: any) {
      return rejectWithValue(
        String(error?.response?.data ?? error?.message ?? "Failed to fetch file")
      );
    }
  }
);